import { render } from "./BookingDetails.vue?vue&type=template&id=4a29684e&scoped=true&ts=true"
import script from "./BookingDetails.vue?vue&type=script&lang=ts"
export * from "./BookingDetails.vue?vue&type=script&lang=ts"

import "./BookingDetails.vue?vue&type=style&index=0&id=4a29684e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a29684e"]])

export default __exports__